var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.292,
    height: 29.129,
    viewBox: "0 0 33.292 29.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "love_1_",
    "data-name": "love (1)",
    d: "M23.669,4a9.639,9.639,0,0,0-7.023,3.048A9.624,9.624,0,0,0,0,13.624C0,23.206,15.455,32.611,16.126,32.98a1.04,1.04,0,0,0,1.072,0c.64-.369,16.095-9.774,16.095-19.356A9.634,9.634,0,0,0,23.669,4ZM16.646,30.863A59.339,59.339,0,0,1,8.6,24.648c-3.262-3.02-6.523-7.094-6.523-11.024A7.543,7.543,0,0,1,15.793,9.29a1.04,1.04,0,0,0,1.7,0,7.543,7.543,0,0,1,13.718,4.333C31.212,21.12,19.336,29.141,16.646,30.863Z",
    transform: "translate(0 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.fc501765303dda025f13f8c4e3ef3318.svg";
export { ForwardRef as ReactComponent };